import React from 'react';
import { func, number, object, oneOfType, string } from 'prop-types';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import CreateIcon from '@material-ui/icons/Create';
import Tooltip from '../Tooltip';
import Typography from '../Typography';
import useStyles from './styles';

const Field = ({
  className,
  style,
  content,
  icon,
  modify,
  name,
  title,
  tooltip,
  type,
  contentStyle,
  spacing = 2,
  iconColor = 'secondary',
  iconAnchorId,
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      name={name}
      className={className}
      style={style}
      alignItems="center"
      justify="space-between"
      spacing={spacing}
    >
      {icon && (
        <Grid item className={`${classes.icons} ${iconAnchorId}`}>
          <Icon component={icon} fontSize="small" color={iconColor} />
        </Grid>
      )}
      <Grid item container direction="column" xs>
        {title && <Typography align="left" content={title} variant="subtitle2" color="secondary" />}
        <Typography align="left" content={content} type={type} variant="body2" style={contentStyle} />
      </Grid>
      <Grid item className={classes.options}>
        {tooltip && <Tooltip content={tooltip} />}
        {modify && (
          <Card className={classes.card} onClick={modify}>
            <CreateIcon fontSize="small" color="primary" />
          </Card>
        )}
      </Grid>
    </Grid>
  );
};

Field.propTypes = {
  className: string,
  style: object,
  content: oneOfType([number, object, string]),
  icon: object,
  modify: func,
  name: string,
  tooltip: object,
  title: oneOfType([number, object, string]),
  type: string,
  contentStyle: oneOfType([object, string]),
  spacing: number,
  iconColor: string,
  iconAnchorId: string,
};

export default Field;
